import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    user:{}
  },
  mutations: {
    // 设置用户信息
    setUser(state, user) {
      state.user = user
    },
  },
  getters:{
    getUser(state){
      return state.user
    }
  }
})
